import { cn } from "../foundations/cn.js";
import { FOCUS_RING } from "../foundations/interaction.js";

/** The box alone, for a card that is itself the checkbox's label. */
export const CHECKBOX_BOX = cn(
  "flex size-4.5 shrink-0 items-center justify-center rounded-xs border border-border-input bg-bg-inset text-text-on-accent",
  "hover:bg-bg-hover data-checked:border-accent-default data-checked:bg-accent-default data-indeterminate:border-accent-default data-indeterminate:bg-accent-default",
  "data-disabled:cursor-default data-disabled:opacity-40",
  FOCUS_RING,
);
